import { connect } from 'react-redux'
import MaintenanceFixTargetComponent from '../components/MaintenanceFixTargetComponent.jsx';
import {
	forwardToFindFixableDetails,
	forwardToFixDetail
} from '../actions';

const mapStateToProps = (state) => ({
	request: state.getIn(['maintenanceFixingReducer', 'request']),
	response: state.getIn(['maintenanceFixingReducer', 'response']),
	options: state.getIn(['maintenanceFixingReducer', 'options']),
	alert: state.getIn(['alertReducer', 'alert']),
})

const mapDispatchToProps = (dispatch) => ({

	findFixableDetails: (cardPk, type) => {
		dispatch(forwardToFindFixableDetails(cardPk, type));
	},

	detailFixed: (detail, card, type, fixer) => {
		dispatch(forwardToFixDetail(detail, card, type, fixer));
	}

})

const MaintenanceFixTargetContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(MaintenanceFixTargetComponent)

export default MaintenanceFixTargetContainer;


// WEBPACK FOOTER //
// ./src/containers/MaintenanceFixTargetContainer.jsx